import React from 'react';
import ShippingDetailsModal from '../admin/ShippingDetailsModal';
import { Order, OrderStatus } from '../../types/order';

interface OrderModalsProps {
  showShippingModal: boolean;
  setShowShippingModal: (value: boolean) => void;
  showConfirmationModal: boolean;
  setShowConfirmationModal: (value: boolean) => void;
  order: Order;
  confirmationMessage: string;
  confirmationAction: () => void;
  handleStatusUpdate: (status: OrderStatus, details?: any) => void;
}

const OrderModals: React.FC<OrderModalsProps> = ({
  showShippingModal,
  setShowShippingModal,
  showConfirmationModal,
  setShowConfirmationModal,
  order,
  confirmationMessage,
  confirmationAction,
  handleStatusUpdate
}) => {
  return (
    <>
      {showShippingModal && (
        <ShippingDetailsModal
          isOpen={showShippingModal}
          orderId={order.orderId}
          onClose={() => setShowShippingModal(false)}
          onConfirm={(shippingDetails) => {
            handleStatusUpdate('SHIPPED', shippingDetails);
            setShowShippingModal(false);
          }}
        />
      )}

      {showConfirmationModal && (
        <div className="fixed inset-0 bg-gray-600 bg-opacity-50 overflow-y-auto h-full w-full z-50">
          <div className="relative top-20 mx-auto p-5 border w-96 shadow-lg rounded-md bg-white">
            <div className="mt-3 text-center">
              <h3 className="text-lg font-medium text-gray-900 mb-4">Confirm Action</h3>
              <p className="text-sm text-gray-500 mb-6">{confirmationMessage}</p>
              <div className="flex justify-center space-x-4">
                <button
                  onClick={() => setShowConfirmationModal(false)}
                  className="px-4 py-2 bg-gray-300 text-gray-700 rounded-md hover:bg-gray-400"
                >
                  Cancel
                </button>
                <button
                  onClick={() => {
                    confirmationAction();
                    setShowConfirmationModal(false);
                  }}
                  className="px-4 py-2 bg-red-600 text-white rounded-md hover:bg-red-700"
                >
                  Confirm
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default OrderModals;
